import {makeStyles} from '@material-ui/core/styles';
import {Theme} from './Theme';

export class Styles {
    static readonly bridge:any = makeStyles( {
        paper: {
            position:"absolute",
            top:"0",
            left:"0",
            width:"100%",
            height:"100%",
            backgroundColor:"white",
            opacity:0.9,
            boxSizing:"border-box",
        },
        nextRoom: {
            position:"absolute",
            top:"50%",
            left:"50%",
            transform : "translate(-50%,-50%)",
            webkitTransform : "translate(-50%,-50%)",
            msTransform : "translate(-50%,-50%)",
            boxSizing:"border-box",
            fontSize:"500%",
            whiteSpace:"nowrap",
            lineHeight:"1.2em",
        },
        nextFloor: {
            position:"absolute",
            top:"50%",
            left:"50%",
            transform : "translate(-50%,-50%)",
            webkitTransform : "translate(-50%,-50%)",
            msTransform : "translate(-50%,-50%)",
            boxSizing:"border-box",
            fontSize:"500%",
            whiteSpace:"nowrap",
            textAlign:"center",
            lineHeight:"1.2em",
        },
    });
    static readonly loading:any = makeStyles( {
        paper: {
            position:"absolute",
            top:"0",
            left:"0",
            width:"100%",
            height:"100%",
            backgroundColor:"white",
            opacity:0.7,
            boxSizing:"border-box",
            zIndex:9999,
        },
        spinner: {
            position:"absolute",
            top:"50%",
            left:"50%",
            transform : "translate(-50%,-50%)",
            webkitTransform : "translate(-50%,-50%)",
            msTransform : "translate(-50%,-50%)",
            boxSizing:"border-box",
        },
    });
    static readonly base:any = makeStyles( {
        root: {
            height:"100%",
            boxSizing:"border-box",
            paddingTop:"4em",
            overflow:"hidden",
            [Theme.breakpoints.down('md')]: {
                paddingRight: "0",
                paddingLeft: "0",
            },
            [Theme.breakpoints.up('md')]: {
                paddingRight: "1em",
                paddingLeft: "1em",
            },
        },
        mainRoot: {
            height:"100%",
            boxSizing:"border-box",
            paddingTop:"3.5em",
            overflow:"hidden",
            position:"relative",
            lineHeight: "1.5em",
        },
        modalRoot: {
            height:"100%",
            boxSizing:"border-box",
            overflowX:"hidden",
            overflowY:"auto",
            paddingTop: "3em",
            lineHeight: "1.4em",
            [Theme.breakpoints.down('md')]: {
                paddingRight: "1em",
                paddingLeft: "1em",
            },
            [Theme.breakpoints.up('md')]: {
                paddingRight: "1em",
                paddingLeft: "1em",
            },
        },
        modalHead: {
            position:"fixed",
            top:"0",
            left:"0",
            width:"100%",
            padding:"0em",
            paddingTop:"0.1em",
            lineHeight:"1em",
            boxSizing:"border-box",
            backgroundColor:Theme.palette.primary.main,
            zIndex:999,
        },
        dialogRoot: {
            boxSizing:"border-box",
            padding: "1em",
        },
        modal: {
            position:"absolute",
            width:"100%",
            height:"100%",
            maxWidth:"460px",
            maxHeight:"620px",
            backgroundColor:"#FFFFFF",
            boxSizing:"border-box",
        },
        alert: {
            position:"absolute",
            width:"100%",
            //height:"100%",
            maxWidth:"240px",
            //maxHeight:"620px",
            backgroundColor:"#FFFFFF",
            boxSizing:"border-box",
        },

        App: {
            width:"100%",
            height:"100%",
            maxWidth:"480px",
            maxHeight:"640px",
            position:"absolute",
            top:"50%",
            left:"50%",
            transform : "translate(-50%,-50%)",
            webkitTransform : "translate(-50%,-50%)",
            msTransform : "translate(-50%,-50%)",
            boxSizing:"border-box",
            boxShadow:"0px 0px 2px 1px #E5E5E5",
            backgroundColor: Theme.palette.primary.contrastText,
            overflow:"hidden",
            //backgroundColor: "#D8F2DA",
        },
        AppBar: {
            padding:"0em 0",
            color: Theme.palette.primary.contrastText,
            fontWeight:"bold",
        },
        changer: {
            top:"auto",
            bottom:"0",
        },
        Toolbar: {
            padding:"0!important",
            paddingLeft:"1em!important",
        },
        grow: {
            flexGrow: 1,
        },
        primary: {
            color: Theme.palette.primary.main,
        },
        primaryText: {
            color: Theme.palette.primary.contrastText,
        },
        secondary: {
            color: Theme.palette.secondary.main,
        },
        link: {
            color: Theme.palette.secondary.dark,
        },
        yes: {
            position:"absolute",
            top:"auto",
            bottom:"1em",
            left:"auto",
            right:"1em",
            color:Theme.palette.primary.contrastText,
        },
        no: {
            position:"absolute",
            top:"auto",
            bottom:"1em",
            left:"1em",
            right:"auto",
            color:Theme.palette.primary.contrastText,
        },
        withIcon: {
            display:"inline-flex",
            verticalAlign:"middle",
        },
        modalBottom: {
            position: "fixed",
            width:"100%",
            padding:"1em 1em",
            boxSizing: "border-box",
            bottom: "0",
            left:"0",
            backgroundColor:"white",
            borderTop:`1px solid #EEEEEE`,
            lineHeight:"1em",
            zIndex:1000,
        },
        modalBottomAbs: {
            position: "absolute",
            width:"100%",
            padding:"1em 1em",
            boxSizing: "border-box",
            bottom: "0.25em",
            left:"0",
            backgroundColor:"white",
            borderTop:`1px solid #EEEEEE`,
            lineHeight:"1em",
            zIndex:1000,
        },
        bottomBar: {
            position: "fixed",
            width:"100%",
            padding:"1em 1em",
            boxSizing: "border-box",
            bottom: "0",
            left:"0",
            backgroundColor:"white",
            borderTop:`1px solid #EEEEEE`,
        },
        bottomAppBar: {
            top: 'auto',
            bottom: 0,
        },        
        middleCenter: {
            position:"absolute",
            top:"50%",
            left:"50%",
            transform : "translate(-50%,-50%)",
            webkitTransform : "translate(-50%,-50%)",
            msTransform : "translate(-50%,-50%)",
        },
        clickable: {
            cursor:"pointer",
        },
        subtitle1: {
            color: Theme.palette.secondary.dark,
        },
        formLabel: {
            color: Theme.palette.primary.main,
        },
        formValue: {
            marginBottom:"1em",
        },
        moveUp: {
            position:"absolute",
            bottom:"0.5em",
            left:"50%",
            transform : "translate(-50%,0%)",
            webkitTransform : "translate(-50%,0%)",
            msTransform : "translate(-50%,0%)",
        },
        moveNext: {
            position:"absolute",
            bottom:"0.5em",
            right:"0.5em",
        },
        fabButton: {
            position: 'absolute',
            zIndex: 1,
            top: -20,
            left: 0,
            right: 0,
            margin: '0 auto',
        },
        story: {
            padding:"1em 0",
            textAlign:"center",
            fontSize:"90%",
        },
        formControl: {
            margin: "0",
            padding: "0",
        },
        barColorWater: {
            backgroundColor:"navy",
        },
        barColorMagenta: {
            backgroundColor:"magenta",
        },
        barColorCyan: {
            backgroundColor:"cyan",
        },
        barColorYellow: {
            backgroundColor:"yellow",
        },
        golds: {
            position:"absolute",
            top:"1.75em",
            right:"0.5em",
        },
        messageBoard: {
            border:"1px solid silver",
            padding:"0.5em",
            paddingTop:"0.25em",
            marginTop: "0.5em",
            lineHeight:"2em",
            fontSize:"90%",
        },
        meters: {
            position:"absolute",
            bottom:"6em",
            left:"0",
            width:"100%",
            padding:"0 1em",
            boxSizing:"border-box", 
        },
        boardPlate: {
            fontSize:"300%",
            textAlign:"center",
            marginTop:"1em",
            lineHeight:"1em",
            marginBottom:"0.3em",
        },
        room: {
            fontSize:"90%",
        },
        happyEnd: {
            textAlign:"center",
            margin:"1em 0",
            marginBottom:"0em",
            color:Theme.palette.secondary.main,
            fontSize:"90%",
        },
        badEnd: {
            textAlign:"center",
            margin:"1em 0",
            marginBottom:"0em",
            color:"gray",
            fontSize:"90%",
        }

    });
}